import React from 'react';

import { getColorFromName } from './colors';
import { Image, Letter, PinWrapper } from './Styles';

export interface AvatarProps {
  className?: string;
  avatarUrl?: string;
  name?: string | null;
  size?: number;
  pin?: JSX.Element;
}

const Avatar: React.FC<AvatarProps> = ({ className, avatarUrl, name = '', size = 24, pin }) => {
  if (avatarUrl) {
    return <Image className={className} size={size} avatarUrl={avatarUrl} />;
  }
  return (
    <Letter className={className} size={size} color={getColorFromName(name)}>
      {name && <span>{name.trim().charAt(0)}</span>}
      {pin && <PinWrapper>{pin}</PinWrapper>}
    </Letter>
  );
};

export default Avatar;
